import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
interface TestimonialCardProps {
  quote: string;
  name: string;
  role: string;
  location: string;
  index: number;
}
function TestimonialCard({
  quote,
  name,
  role,
  location,
  index
}: TestimonialCardProps) {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  return <motion.div ref={ref} className="p-8 rounded-3xl bg-white border border-rose-100 shadow-lg" initial={{
    opacity: 0,
    y: 40
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.5,
    delay: index * 0.15
  }} data-id="element-206">
      {/* Star rating */}
      <div className="text-2xl mb-4 tracking-wider" data-id="element-207">🌸🌸🌸🌸🌸</div>

      {/* Quote */}
      <p className="text-slate-700 leading-relaxed mb-6 text-lg" data-id="element-208">"{quote}"</p>

      {/* Author */}
      <div className="border-t border-rose-100 pt-4" data-id="element-209">
        <p className="font-bold text-slate-900" data-id="element-210">{name}</p>
        <p className="text-sm text-slate-500" data-id="element-211">
          {role}, {location}
        </p>
      </div>
    </motion.div>;
}
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Increíble la cantidad de diseños. Empecé vendiendo invitaciones y en un mes ya recuperé la inversión 10 veces. ¡Un negocio hermoso!',
    name: 'María G.',
    role: 'Emprendedora digital',
    location: 'México'
  }, {
    quote: 'El manual es clarísimo. Nunca había impreso nada profesional y con la guía me salió perfecto desde el primer intento.',
    name: 'Laura P.',
    role: 'Mamá emprendedora',
    location: 'Argentina'
  }, {
    quote: 'Las flores de papel y los números 3D son una locura de hermosos. Mis clientes quedan encantados y me piden más. ¡100% recomendado!',
    name: 'Ana R.',
    role: 'Decoradora de fiestas',
    location: 'Colombia'
  }];
  const headerRef = useRef(null);
  const isHeaderInView = useInView(headerRef, {
    once: true
  });
  return <section className="w-full bg-white py-20 sm:py-28" data-id="element-212">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-213">
        {/* Header */}
        <motion.div ref={headerRef} className="text-center mb-16" initial={{
        opacity: 0,
        y: 30
      }} animate={isHeaderInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-214">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-slate-900 mb-4" data-id="element-215">
            💬 Lo que dicen nuestras clientas
          </h2>
          <p className="text-xl sm:text-2xl font-bold text-rose-500" data-id="element-216">
            Ellas Ya Están Generando Ingresos 🌟
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8" data-id="element-217">
          {testimonials.map((testimonial, index) => <TestimonialCard key={testimonial.name} quote={testimonial.quote} name={testimonial.name} role={testimonial.role} location={testimonial.location} index={index} data-id="element-218" />)}
        </div>

        {/* Price CTA after testimonials */}
        <motion.div className="mt-14 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-219">
          <p className="text-lg text-slate-600 mb-4" data-id="element-220">
            Ellas ya empezaron.{' '}
            <span className="font-bold text-slate-900" data-id="element-221">¿Qué esperás vos?</span>
          </p>
          <a href="https://magiadigital.online/checkouts/cn/hWN9TYd7nIHOv98RJ6pjImQM/es-ar?_r=AQABPAMwqwcFHsaNx77xI9-vQVNjUUJUKqqMcQTwOKcBl4s&preview_theme_id=158917099778" target="_blank" rel="noopener noreferrer" className="shimmer-btn inline-flex items-center justify-center px-10 py-4 bg-gradient-to-r from-rose-500 to-pink-500 text-white text-lg font-bold rounded-2xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300" data-id="element-222">
            🛒 Quiero mi Kit — $27.990 ARS
          </a>
          <p className="mt-2 text-sm text-slate-400" data-id="element-223">
            <span className="line-through" data-id="element-224">$89.990</span> →{' '}
            <span className="font-bold text-rose-500" data-id="element-225">$27.990 ARS</span> · pago
            único
          </p>
        </motion.div>
      </div>
    </section>;
}